import { render, staticRenderFns } from "./Mag-Login.vue?vue&type=template&id=7c775a02&scoped=true"
import script from "./Mag-Login.vue?vue&type=script&lang=js"
export * from "./Mag-Login.vue?vue&type=script&lang=js"
import style0 from "./Mag-Login.vue?vue&type=style&index=0&id=7c775a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c775a02",
  null
  
)

export default component.exports